import { render, staticRenderFns } from "./LogImportDetail.vue?vue&type=template&id=08c09d41&"
import script from "./LogImportDetail.vue?vue&type=script&lang=js&"
export * from "./LogImportDetail.vue?vue&type=script&lang=js&"
import style0 from "./LogImportDetail.vue?vue&type=style&index=0&id=08c09d41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports